import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  ZAxis,
  ScatterChart,
  Scatter,
  Label,
  LabelList,
  ReferenceLine,
  Tooltip,
} from "recharts";

import React, { useState, useEffect } from "react";

import { numberFormatter } from "../../utils";


const GrossMarginChart2 = (props: any) => {
  const [data, setData] = useState([]);
  const {selectedMaskStatus,selectedVendor,supplier} = props;
  const refX = props?.performanceGraphData?.weightedNiaPcnt*100;
  const refY = props?.performanceGraphData?.weightedGM*100;
  useEffect(() => {
    if (props?.performanceGraphData) {
      setData(props.performanceGraphData?.peer);
    }
  }, [props]);

const customTooltip = ({ active, payload }: any) => {
      if (active && payload && payload.length) {
        const data = payload[0].payload;
        
        return (
          <div className="custom-tooltip">
            <p className="label" style={{ padding: "0", margin: "0" }}>
              <label
                style={{
                  color: "#C8C8C8",
                  fontSize: "10px",
                  fontWeight: "normal",
                }}
              >
                Supplier :{" "}
              </label>
              <label
                style={{
                  color: "#EAEAEA",
                  fontSize: "10px",
                  fontWeight: "bold",
                }}
              >
                {data.peer_vendor_name}
              </label>
            </p>
            <p className="label" style={{ padding: "0", margin: "0" }}>
              <label
                style={{
                  color: "#C8C8C8",
                  fontSize: "10px",
                  fontWeight: "normal",
                }}
              >
                Spend :{" "}
              </label>
              <label
                style={{
                  color: "#EAEAEA",
                  fontSize: "10px",
                  fontWeight: "bold",
                }}
              >
              {numberFormatter(data.invCost,0,'$')}
              </label>
            </p>
            <p className="label" style={{ padding: "0", margin: "0" }}>
                      <label
                        style={{
                          color: "#C8C8C8",
                          fontSize: "10px",
                          fontWeight: "normal",
                        }}
                      >
                       Last Year NIA% of Spend :{" "}
                      </label>
                      <label
                        style={{
                          color: "#EAEAEA",
                          fontSize: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {numberFormatter(data.rebate_base_lastyear,0)}%
                      </label>
            </p>
            <p className="label" style={{ padding: "0", margin: "0" }}>
            <label
              style={{
                color: "#C8C8C8",
                fontSize: "10px",
                fontWeight: "normal",
              }}
            >
              Last Year Gross Margin %​ :{" "}
            </label>
            <label
              style={{
                color: "#EAEAEA",
                fontSize: "10px",
                fontWeight: "bold",
              }}
            >
              {numberFormatter(data.gm,0,)}%
            </label>
            </p>
          </div>
        );
      }
    };

    console.log(selectedVendor,'sel')

  return (
    <div className="w-[29vw] flex flex-col items-center h-[32vh] p-1">
      
      <ResponsiveContainer width="100%" height="100%">
        <ScatterChart
          width={400}
          height={400}
          data={data}
          margin={{
            top: 30,
            right: 50,
            bottom: 20,
            left: 30,
          }}
        >
          <XAxis
            type="number"
            dataKey="rebate_base_lastyear"
            stroke="black"
            tickFormatter={(val) => `${numberFormatter(val, 0)}%`}
            domain={['dataMin - 5', 'dataMax + 5']}
          >
            <Label
              value="Last Year NIA% of Spend"
              offset={0}
              position="bottom"
              style={{ fill: "black" }}
            />
          </XAxis>
          <YAxis
            type="number"
            dataKey="gm"
            stroke="black"
            interval={0}
            tickFormatter={(val) => `${numberFormatter(val, 0)}%`}
            domain={['dataMin - 5', 'dataMax + 5']}
          >
            <Label
              value={`Last Year Gross Margin %​`}
              angle={-90}
              offset={0}
              position="insideLeft"
              style={{ fill: "black", textAnchor: "middle" }}
            />
          </YAxis>
          <ZAxis type="number"  range={data?.length <= 10 ? [350, 350] : [350, 350]}></ZAxis>
         <ReferenceLine x={refX} label={{ position: 'top', fill: '#ce9178', value: numberFormatter(refX, 2) + '%', fontStyle: 'italic' }} stroke="black" strokeDasharray="5 3" opacity={0.3} />

          <ReferenceLine y={refY} label={{ position: 'right', fill: '#ce9178', value: numberFormatter(refY, 2) + '%', fontStyle: 'italic' }} stroke="black" strokeDasharray="5 3" opacity={0.3} />
          <Tooltip
              contentStyle={{
                color: "black",
                backgroundColor: "rgb(26, 25, 22)",
              }}
              cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
              content={customTooltip}
            />
          {data?.map((d: any, index: number) => {
            return (
              <>
              {supplier?.includes(d?.peer_vendor_name)&&<Scatter
                key={index}
                data={[d]}
                fill={d?.peer_vendor_name===selectedVendor[0]?"#2ba1c3":'#faf275'}
               
              >
                {!selectedMaskStatus &&<LabelList dataKey="peer_vendor_name" fill="#fff"  fontSize={'1.4vh'} position={'right'}/>}
              </Scatter>}
              </>
            );
          })}
        </ScatterChart>
      </ResponsiveContainer>

    </div>
  );
};

export default GrossMarginChart2;
